import RemittanceForm from './RemittanceForm'
import RemittanceList from './RemittanceList'

export { RemittanceForm, RemittanceList }

export default {
  RemittanceForm,
  RemittanceList
}
